import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';

import { Stack, CircularProgress } from '@mui/material';
import { authenticatedGetRequest } from '../RestApi';
import { ErrorBox } from '../ErrorBox';


export function EarningsCallCitation({citation}) {
    const [data, setData] = useState(null);
    const [apiWait, setApiWait] = useState(false);
    const [errorState, setErrorState] = useState(false);

    useEffect(() => {
        if (citation) {
            // console.log("citation", citation);
            setApiWait(true);
            // console.log("makeGetRequest", process.env.REACT_APP_API_BASE_URL + '/av?function=EARNINGS_CALL_TRANSCRIPT&symbol=' + citation?.ticker + '&quarter=' + citation?.reporting_year + 'Q' + citation?.reporting_quarter);
            
            const url = `${process.env.REACT_APP_EARNINGS_CALL_API_BASE_URL}/${citation?.ticker.toUpperCase()}/${citation?.reporting_year}Q${citation?.reporting_quarter}.json`;
            authenticatedGetRequest(url)
            .then((data) => {
                // console.log("data", data);
                setData(data);
            })
            .catch((error) => {
                setErrorState(true);
            }).finally(() => {
                setApiWait(false);
            });
        }
    }, [citation]);

    // const autoScrollCallback = useCallback(
    //     (node) => {
    //         node?.scrollIntoView({
    //             behavior: "smooth",
    //             block: "start",
    //             inline: "center"
    //         });
    //     }, []
    // );

    useEffect(() => {
        // Scroll to the element with the ID from the fragment identifier
        if (data) {
            const element = document.getElementById('revelata-highlight-0');
            if (element) {
                element.scrollIntoView({
                    behavior: 'instant', 
                    block: "center",
                    inline: "center"
                })
            }
        }
    }, [data])

    // Error handler
    if (errorState) {
        return <ErrorBox />
    }

    // Show spinner when waiting for API response
    if (apiWait || data === null) {
        return (
            <Stack alignItems="center" justifyContent="center" height="100%">
                <CircularProgress disableShrink={true} />
            </Stack>
        )
    }

    return (
        <Box sx={{width: '90%', mt: { xs: 0, sm: '10%'}, mb: { xs: 0, sm:'5%'}, justifyContent: 'center', alignItems: 'center'}}>
            <Box sx={{ 
                width: '100%',
                p: 2,
                mb: 2,
                border: 1, 
                borderColor: 'grey.800',
                borderRadius: 1
            }}>
                <Typography variant="h6">
                {citation?.reporting_year} Q{citation?.reporting_quarter} Earnings Call Transcript 
                </Typography>
            </Box>
            
            <Box sx={{ 
                maxHeight: '70vh',
                overflowY: 'auto',
                p: 2,
                borderRadius: 1,
                border: 1,
                borderColor: 'grey.800',
                bgcolor: '#ffffff'
            }}>
                    {
                        data['transcript'].map((utterance, idx) => {                            
                            return (
                                <Box key={idx} sx={{ mb: 3 }}>
                                    <Typography variant="h6" sx={{ mb: 1, color: '#000000' }}>
                                    {utterance.speaker} ({utterance.title}) 
                                    </Typography>
                                    {                                     
                                        utterance.content.split("\n\n").map((paragraph, paragraph_idx) => {
                                            return (
                                                <Typography key={paragraph_idx} component={'div'} sx={{ color: '#000000' }}>
                                                    <p>
                                                    {
                                                        idx === citation.idx && paragraph_idx === citation.paragraph_idx 
                                                        ? 
                                                        <span id="revelata-highlight-0" style={{backgroundColor: 'yellow'}}>{paragraph}</span>
                                                        : 
                                                        paragraph
                                                    }
                                                    </p>
                                                </Typography>                        
                                            )
                                        })
                                    }
                                </Box>
                            )
                        })
                    }
            </Box>
        </Box>
    );
}
export default EarningsCallCitation;